var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "input-search", class: ["input-search", _vm.classDropResult] },
    [
      !_vm.isMobile
        ? _c("div", {
            class: ["overlay", _vm.classDropResult],
            on: { click: _vm.closeSearchBlock },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            "input-search__wrapper",
            _vm.classDropResult,
            { _filled: _vm.inputValue.length },
          ],
        },
        [
          _vm.isMobile
            ? _c(
                "button",
                {
                  staticClass: "close-button",
                  on: { click: _vm.closeSearchBlock },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "11",
                        height: "18",
                        viewBox: "0 0 11 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M1.29823 8.05477C0.900475 8.46157 0.900475 9.12111 1.29823 9.52791L8.42786 16.8196C8.82562 17.2264 9.47051 17.2264 9.86826 16.8196C10.266 16.4128 10.266 15.7532 9.86826 15.3464L3.45883 8.79134L9.86826 2.23624C10.266 1.82945 10.266 1.1699 9.86826 0.763105C9.47051 0.356309 8.82562 0.356309 8.42786 0.763105L1.29823 8.05477Z",
                          fill: "#333332",
                          stroke: "white",
                          "stroke-width": "0.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "svg",
            {
              staticClass: "input-search__loop",
              attrs: {
                width: "24",
                height: "24",
                viewBox: "0 0 24 24",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  d: "M15.9937 10.5194C15.9937 13.5648 13.5325 16.0336 10.4963 16.0336C7.46022 16.0336 4.99902 13.5648 4.99902 10.5194C4.99902 7.47396 7.46022 5.00517 10.4963 5.00517C13.5325 5.00517 15.9937 7.47396 15.9937 10.5194ZM15.0537 16.4899C13.7906 17.4614 12.2108 18.0388 10.4963 18.0388C6.35627 18.0388 3 14.6722 3 10.5194C3 6.36652 6.35627 3 10.4963 3C14.6364 3 17.9927 6.36652 17.9927 10.5194C17.9927 12.2293 17.4236 13.8058 16.4651 15.069L21 19.5426L19.6266 21L15.0537 16.4899Z",
                  fill: "#474747",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.inputValue,
                expression: "inputValue",
              },
            ],
            staticClass: "input-search__input",
            attrs: { type: "text", placeholder: "Поиск по сайту" },
            domProps: { value: _vm.inputValue },
            on: {
              focus: _vm.onFocusInput,
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.submitHandler.apply(null, arguments)
              },
              input: function ($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.inputValue = $event.target.value
              },
            },
          }),
          _vm._v(" "),
          _vm.isMobile && _vm.inputValue
            ? _c(
                "button",
                {
                  staticClass: "clear-search-input",
                  on: { click: _vm.clearInputValue },
                },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "14",
                        height: "14",
                        viewBox: "0 0 14 14",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M13.7662 0.233573C14.0776 0.545004 14.0776 1.04993 13.7662 1.36136L1.36112 13.7664C1.04969 14.0779 0.54476 14.0779 0.233329 13.7664C-0.0781018 13.455 -0.0781018 12.9501 0.233329 12.6386L12.6384 0.233573C12.9498 -0.0778577 13.4548 -0.0778577 13.7662 0.233573Z",
                          fill: "#333332",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M0.233329 0.233573C0.54476 -0.0778577 1.04969 -0.0778577 1.36112 0.233573L13.7662 12.6386C14.0776 12.9501 14.0776 13.455 13.7662 13.7664C13.4548 14.0779 12.9498 14.0779 12.6384 13.7664L0.233329 1.36136C-0.0781018 1.04993 -0.0781018 0.545004 0.233329 0.233573Z",
                          fill: "#333332",
                        },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.isShowDropResult
        ? _c("drop-search-result", {
            attrs: {
              mod: _vm.classDropResult,
              data: _vm.data,
              "search-string": _vm.inputValue,
              "is-mobile": _vm.isMobile,
              "new-local-storage-history": _vm.newLocalStorageHistory,
            },
            on: { setQuery: _vm.onSetQuery },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }